import { Component } from '@angular/core';

@Component({
    selector: 'app-event-policy',
    imports: [],
    templateUrl: './event-policy.component.html',
    styleUrl: './event-policy.component.scss'
})
export class EventPolicyComponent {

}
